<template>
  <component
    :is="is"
    class="text"
  >
    <slot/>
  </component>
</template>

<script>
  import dynamicComponent from '@/mixins/dynamic-component';

  export default {
    mixins: [dynamicComponent],
  };
</script>

<style
  scoped
  lang="scss"
>
  .text {
    font-size: 1.8rem;
    font-weight: font-weight(bold);
    letter-spacing: 0.05em;
  }
</style>
